import React, { Component } from "react";
import {
  NormalButton,
  NormalModal,
  NormalSelect,
  NormalInput,
} from "component/common";
import "./style.scss";
import { connect } from "react-redux";
import closeIcon from "assets/images/close.png";
import Voucher from "assets/images/voucher.png";
import { Toast } from "service/toast";
import { bindActionCreators } from "redux";
import { history } from "helpers";
import {
  getCommonApi,
  commonCreateApi,
  commonUpdateApi,
  commonDeleteApi,
} from "redux/actions/common";
import printJS from "print-js";
// import logo from 'assets/images/logo.png'
import html2canvas from "html2canvas";
//import jspdf from "jspdf";
import ReactToPrint from "react-to-print";
import { PDFDownloadLink } from "@react-pdf/renderer";

import EinvoiceGreenLogo from "assets/images/einvoicegreenlogo.png";
import EinvoiceRedLogo from "assets/images/einvoiceredlogo.png";

import Thermal from "./Thermal";
import PrintPreview from "./PrintPreview";
import PrepaidDesc from "./PrepaidDesc";
import jsPDF from "jspdf";
import { PrintView } from "component/common/PrintView";
import ThermalMalaysia from "./ThermalMalaysia";
import Coulisseheir from "./Coulisseheir";
import Luxelle from "./Luxelle";
import CoulisseheirPrint from "./Coulisseheir/coulisseheir";
import LuxelleNew from "./Luxelle/luxelleNew/luxelle";
// import PrintView from "component/common/PrintView";
import { QRCodeSVG } from "qrcode.react";
import Webcam from "react-webcam";

const NewLineText = (text) => {
  if (text) {
    console.log("textss", text);
    const newText = text.split(/\n|\\n/).map((str) => (
      <p className="col-12" style={{ lineHeight: "1.0rem" }}>
        {str}
      </p>
    ));

    return newText;
  }
};

//const termsText = `Terms and Condition: \n 1: Any free sessions, complimentary service, rewards programme purchased all are non-exchangeable or refundable. \n 2: All service packages are valid for twelve months from the date of purchase. \n 3: Deposits for A La carte service will be for forfeited for cancellation of less than 24hours before the treatment. \n 4: a) Deposit for package service will be forfeited if customer does not come to redeem the booked package after 12 months from the paid date. \n b) Deposits for package : If customer wants to make appointment for next treatment, their payment must paid more than the next treatment course. For any late cancellation or “no-show”, the company has the right to deduct 1 x treatment course from their treatment package (will be treated as the treatment is taken). \n 5: If customer arrived late for appointment,the company has the rights to reduce the session time accordingly or complete the treatment by the appointed time and charge full amount of the booked treatment.(Applicable for A La carte service and package) \n 6: Embrace Beauty Pte Ltd reserves the right to charge all utilized service at ala carte prices upon termination of the package. \n 7: Refund Policy: \n a) If customer do not wish to proceed with the services and made known to the company within the cooling off period of 5 working days (exclude Sat,Sun & Public Holidays),the company will refund 100% of what the customer had paid. The redeemed treatment of the package is strictly non-refundable . Mode of refund will be in cheque. \n b) Prepaid packages AFTER cooling-off period is non-refundable unless the customer provide a medical note. The balanced and un-utilized sessions will be pro-rated based on ala-carte price minus an administrative charges (10%) and refunded in the form of a cheque. The redeemed treatment of the package is strictly non-refundable. \n c) Product exchange is applicable within 5 working days from the date of sale and only if the product is intact and deemed in good condition with the discretion of the management final judgement.\n \n The Company reserves the right to amend the terms and conditions herein and/or the specific terms and conditions at anytime and the customer shall be bound by the amended terms and conditions. Notice of the amendments may be given by the Company to the customer in such a manner, as the Company deem fit and proper.`;
const termsText = ``;

const pageStyle = `
  @page {
    size: 100mm;
  }

  @media all {
    #printableAreaThermal {
      display: none;
    }
  }

  @media print and (color) {
    * {
       -webkit-print-color-adjust: exact;
       print-color-adjust: exact;
    }
 }

  @media print {
    #printableAreaThermal {
      page-break-before: always;
     box-shadow:  inset 0 0 0 1000px #000;
     display:flex;
     justify-content: center;
     align-items: center;
     width: 100%;
     position: relative;

      
    }
    .printableAreaInner
    {
      width:500px;
      position: absolute;
      left: 0; 
  right: 0; 
  margin-left: auto; 
  margin-right: auto; 
    }
  }
`;

export class CustomerReceiptClass extends Component {
  state = {
    responseData: {},
    downloadlLink: "",
    receiptDownloadLink: "",
    isOpenModal: false,
    voucherPromo: [],
    cust_sign: "",
    isPrintPdfClick: false,
    printData: {},
    isPrintPdfPreview: false,
    templateList: [],
    isBackendPrintEnable: true,

    //Einvoice
    openEinvoice: false,
    einvoiceDetails: {},
    einvoiceBtnStatus: false,
    tinInputValue: "",
    addressInputValue: "",
    errors: {
      tin: false,
      address: false,
    },
    qrCode: "",
    reg_no: "",
    state: "",
    SST: "",

    // MerchantReceiptImg
    isMerchantPopup: false,
    photoSections: {},
    selectedMethods: [],

  };

  componentDidMount() {
    // let {  cartId } = this.props;
    this.getInvoiceSettingList();

    this.handleVoucherPromo();
    this.getListData();
    this.handlePrint();

    //this.handleItemSettings();

    // MerchantReceiptImg
    navigator.getMedia =
      navigator.mediaDevices.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia;

    navigator.mediaDevices.getUserMedia(
      { video: true },
      () => {
        this.setState((prevState) => ({
          photoSections: {
            ...prevState.photoSections,
            visa: { ...prevState.photoSections.visa, isCameraAvailable: true },
            atome: {
              ...prevState.photoSections.atome,
              isCameraAvailable: true,
            },
            master: {
              ...prevState.photoSections.master,
              isCameraAvailable: true,
            },
          },
        }));
      },
      () => {
        this.setState((prevState) => ({
          photoSections: {
            ...prevState.photoSections,
            visa: { ...prevState.photoSections.visa, isCameraAvailable: false },
            atome: {
              ...prevState.photoSections.atome,
              isCameraAvailable: false,
            },
            master: {
              ...prevState.photoSections.master,
              isCameraAvailable: false,
            },
          },
        }));
      }
    );
  }

    // MerchantReceiptImg
  handlePhotoSections = () => {
    const photoSections = {};
    const { responseData } = this.state;
    let { taud_data } = responseData;
    const nonCashMethods = taud_data.filter(
      (item) => item.pay_type_name?.toLowerCase().trim() !== "cash"
    );
    const cashMethods = taud_data.filter(
      (item) => item.pay_type_name?.toLowerCase().trim() === "cash"
    );
    const prioritized = [...nonCashMethods, ...cashMethods];
    //console.log(prioritized);
    //const selectedMethods = prioritized.slice(0, 4);
    //Yoonus
    const selectedMethods = taud_data.slice(0, 5);
    console.log(selectedMethods);
    selectedMethods.forEach((item, index) => {
      //const key = item.pay_type_name;
      //Yoonus
      //const key = item.pay_type_name + "-" + (index + 1);
      const key = `${item.pay_type_name}-${index + 1}`
      photoSections[key] = {
        image: null,
        isCameraAvailable: true,
        showCamera: false,
        isUploading: false,
      };
    });

    this.setState({ photoSections: photoSections, selectedMethods: selectedMethods  });
  };

  // MerchantReceiptImg
  handlePhotoSectionsNew = () => {
    const photoSections = {};
    const { responseData } = this.state;
    let { taud_data } = responseData;
    //Yoonus
    const uniqueTaud_data = taud_data.filter(
    (item, index, self) =>
      index === self.findIndex(obj => obj.pay_type_name === item.pay_type_name)
    );

    console.log(uniqueTaud_data, "uniqueTaud_data :");
    //const uniqueTaud_data = [...new Set(taud_data)];    
    const nonCashMethods = uniqueTaud_data.filter(
      (item) => item.pay_type_name?.toLowerCase().trim() !== "cash" 
      && item.pay_type_name?.toLowerCase().trim() !== "credit note"
      && item.pay_type_name?.toLowerCase().trim() !== "prepaid"
    );
    console.log(nonCashMethods, "nonCashMethods :");
    const creditMethods = uniqueTaud_data.filter(
      (item) => item.pay_type_name?.toLowerCase().trim() === "credit note"
    );
    console.log(creditMethods, "creditMethods :");
    const prepaidMethods = uniqueTaud_data.filter(
      (item) => item.pay_type_name?.toLowerCase().trim() === "prepaid"
    );
    console.log(prepaidMethods, "prepaidMethods :");
    const cashMethods = uniqueTaud_data.filter(
      (item) => item.pay_type_name?.toLowerCase().trim() === "cash"
    );
    console.log(cashMethods, "cashMethods :");
    const prioritized = [...nonCashMethods, ...cashMethods, ...creditMethods, ...prepaidMethods];
    console.log(prioritized, "prioritized :");
    const selectedMethods = prioritized.slice(0, 7);
    selectedMethods.forEach((item) => {
      const key = item.pay_type_name;
      photoSections[key] = {
        image: null,
        isCameraAvailable: true,
        showCamera: false,
        isUploading: false,
      };
    });

    this.setState({ photoSections: photoSections, selectedMethods: selectedMethods });
  };

  // MerchantReceiptImg
  componentDidUpdate(prevProps, prevState) {
    if (prevState.responseData !== this.state.responseData) {
      this.handlePhotoSections();
    }
  }

  getListData = () => {
    this.props
      .getCommonApi(
        `customerreceiptprint/?sa_transacno=${this.props.match.params.id}`
      )
      .then(async (res) => {
        this.setState({
          responseData: res,
          einvoiceBtnStatus: res?.einvoice_submitted,
        });

        if (res?.company_hdr?.cust_sig) {
          await this.setState({ cust_sign: res?.company_hdr?.cust_sig });
        }
      });
  };

  // getInvoiceSettingList
  getInvoiceSettingList = () => {
    this.props.getCommonApi(`invoicetemplateconfig/`).then(async (res) => {
      let { data, status } = res;
      if (status == 200) {
        if (data && data.length > 0) {
          let filterOriginalList = data;
          console.log(filterOriginalList, "filterOriginal");
          const modifiedList = filterOriginalList.reduce(
            (result, item) => {
              result[item.type].push(item);
              return result;
            },
            { headerList: [], footerList: [], bodyList: [] }
          );
          let filterList = [];
          filterList.push(modifiedList);
          console.log(modifiedList, "modifiedList");
          this.setState({ templateList: filterList });
        }
      }
    });
  };

  //voucherpromo api
  handleVoucherPromo = (data) => {
    let { voucherPromo } = this.state;
    this.props.getCommonApi(`voucherpromo/?page=1&limit=12`).then((res) => {
      this.setState({
        voucherPromo: res?.data?.dataList,
      });
      console.log(voucherPromo, "voucher");
      console.log(res, "voucherpromo");
    });
  };

  // for get Print response
  handlePrint = () => {
    // window.print();
    let { isBackendPrintEnable } = this.state;
    let { tokenDetails } = this.props;
    if (tokenDetails.studioAbooking) {
      this.props
        .commonCreateApi(
          `studioinvoice/?sa_transacno=${this.props.match.params.id}`
        )
        .then(async (res) => {
          console.log(res, "response");
          this.setState({ downloadlLink: res.data });
          if (res?.smallreceiptprint) {
            this.setState({ receiptDownloadLink: res.smallreceiptprint });
          }
          if (res?.data) {
            if (this.props.tokenDetails?.quickprint) {
              if (this.props.tokenDetails?.thermalprint) {
                if (isBackendPrintEnable) {
                  printJS(res?.data);
                } else {
                  await this.setState({
                    isPrintPdfClick: true,
                  });
                }
              } else {
                if (isBackendPrintEnable) {
                  printJS(res?.data);
                } else {
                  await this.setState({
                    isPrintPdfPreview: true,
                  });
                }
              }
            }
          }
        });
    } else {
      this.props
        .getCommonApi(`receiptpdf/?sa_transacno=${this.props.match.params.id}`)
        .then(async (res) => {
          console.log(res, "response");
          this.setState({ downloadlLink: res.data });
          if (res?.data) {
            if (this.props.tokenDetails?.quickprint) {
              if (this.props.tokenDetails?.thermalprint) {
                if (isBackendPrintEnable) {
                  printJS(res?.data);
                } else {
                  await this.setState({
                    isPrintPdfClick: true,
                  });
                }
              } else {
                if (isBackendPrintEnable) {
                  printJS(res?.data);
                } else {
                  await this.setState({
                    isPrintPdfPreview: true,
                  });
                }
              }
            }
          }
        });
    }
  };

  //modal
  handleDialog = () => {
    let { isOpenModal } = this.state;
    isOpenModal = !isOpenModal;
    this.setState({
      isOpenModal,
    });
  };
  closeDialog = () => {
    let { isOpenModal } = this.state;
    isOpenModal = false;
    this.setState({
      isOpenModal: false,
    });
  };

  // for share reciept
  handleShare = () => {
    this.props
      .commonCreateApi(
        `receiptpdfsend/?sa_transacno=${this.props.match.params.id}`
      )
      .then((res) => {
        //this.setState({ responseData: res });
        if (res.status == 200) {
          Toast({
            type: "success",
            message: res?.message ?? "Email sent succesfully",
          });
        }
      });
  };

  handleData = (data) => {
    console.log(data, "data");
    this.props
      .commonCreateApi(`voucherpromo/addvoucher/`, {
        sa_transacno: this.props.match.params.id,
        voucherpromo_id: data?.id,
      })
      .then((res) => {
        if (res?.status === 200) {
          Toast({
            type: "success",
            message: res?.message,
          });
          this.setState({ isOpenModal: false });
        }
      });
  };

  // for send sms reciept
  handleSendSMS = () => {
    this.props
      .commonCreateApi(
        `receiptpdfsendsms/?sa_transacno=${this.props.match.params.id}`
      )
      .then((res) => {});
  };

  onSubmit = async (body) => {
    let { voucher_desc, isactive } = this.state;
    let data = {
      voucher_desc: voucher_desc,
      isactive: isactive,
    };
    this.props.commonCreateApi(`voucherpromo/`, body).then((key) => {
      let { status, data } = key;
    });
  };

  handleSendSMSVoucher = () => {
    this.props
      .commonCreateApi(
        `receiptpdfsendsms/?sa_transacno=${this.props.match.params.id}`
      )
      .then((res) => {});
  };

  // printdiv = (divHtml) => {
  //   let headstr =
  //     "<html><head><title></title></head><body onafterprint=`self.close()``>";
  //   let footstr = "</body></html>";
  //   let newstr = document.getElementById(divHtml).innerHTML;
  //   let oldstr = document.body.innerHTML;
  //   document.body.innerHTML = headstr + newstr + footstr;
  //   window.print();
  //   document.body.innerHTML = oldstr;
  //   return false;
  // };

  handleImageToPrint = async () => {
    const printableAreaDiv = document.getElementById("printableArea");
    html2canvas(printableAreaDiv, {
      logging: true,
      letterRendering: 1,
      allowTaint: false,
      useCORS: true,
      scale: 6,
    }).then((canvas) => {
      const myImage = canvas.toDataURL("image/png");
      printJS({
        printable: myImage,
        type: "image",
        onPrintDialogClose: () => this.handleCallBackPrint(),
      });
    });
  };
  handleCallBackPrint = () => {
    window.location.reload();
  };

  handleThermalPrinter = () => {
    document.getElementById("printableAreaThermal").style.display = "block";
    document.getElementById("printableArea").style.display = "none";
    const thermalPrintableArea = document.getElementById(
      "printableAreaThermal"
    );
    // html2canvas(thermalPrintableArea, {
    //   logging: true,
    //   letterRendering: 1,
    //   allowTaint: false,
    //   useCORS: true,
    //   scale: 6,
    // }).then((canvas) => {
    //   const myImage = canvas.toDataURL("image/png");
    //   printJS({
    //     printable: myImage,
    //     type: "image",
    //     onPrintDialogClose: () => this.handleCallBackPrint(),
    //   });
    // });
    // this.handleCallBackPrint();
  };

  handlePrintPdfFormat = (url) => {
    this.setState({
      isPrintPdfClick: false,
    });
    if (url) {
      printJS(url);
      // var a = document.createElement("a");
      // a.setAttribute("download", `${new Date()}.pdf`);
      // a.setAttribute("href", url);
      // a.click();
      //window.open(url);
    }
  };

  // handlePrintPreview
  handlePrintPreview = (url) => {
    this.setState({
      isPrintPdfPreview: false,
    });

    if (url) {
      printJS(url);
      // var a = document.createElement("a");
      // a.setAttribute("download", `${new Date()}.pdf`);
      // a.setAttribute("href", url);
      // a.click();
      //window.open(url);
    }
  };

  // handleCheckStatus
  handleChangeCheckStatus = (arrayData, name) => {
    if (arrayData) {
      const status = arrayData.some(
        (obj) =>
          obj.hasOwnProperty("name") &&
          obj.name === name &&
          obj.checked === true
      );
      return status;
    }
  };

  handleSignSaveClick = (imgData) => {
    // var block = imgData.split(";");
    // // Get the content type of the image
    // var contentType = block[0].split(":")[1]; // In this case "image/gif"
    // // get the real base64 content of the file
    // var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."

    // // Convert it to a blob to upload
    // var blob = this.b64toBlob(realData, contentType);

    let formData = new FormData();
    formData.append("transaction_no", this.props.match.params.id);
    formData.append(
      "cust_sig",
      this.dataURLtoFile(imgData, `${this.props.match.params.id}.jpeg`)
    );

    this.props.commonCreateApi(`tempcustsigninvoice/`, formData).then((key) => {
      let { status, data, message } = key;
      if (status == 201) {
        history.push(
          `/admin/transactionhistory/print/bill/${this.props.match.params.id}`
        );
        Toast({
          type: "success",
          message: message,
        });
        this.getListData();
      } else {
        Toast({
          type: "success",
          message: message,
        });
      }
    });
  };
  dataURLtoFile = (dataurl, filename, mime) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };
  printIfContentExists = () => {
    setTimeout(function () {
      window.print();
    }, 2000);
  };

  //Einvoice and MerchantImg
  handleEinvoicePopup = () => {
    let { einvoiceBtnStatus } = this.state;
    this.setState({
      openEinvoice: true,
    });
    let apiUrl = einvoiceBtnStatus
      ? `einvoice/submit/${this.props.match.params.id}/`
      : `einvoice/confirm/${this.props.match.params.id}/`;
    this.props.getCommonApi(apiUrl).then((res) => {
      if (res?.data) {
        this.setState({
          einvoiceDetails: res?.data,
          tinInputValue: res?.data?.customer.TIN,
          SST: res?.data?.customer?.SST,
          reg_no: res?.data?.customer?.reg_no,
          state: res?.data?.customer?.state,
        });
      } else {
        let date = res?.sumbmitted_date?.slice(0, 10);
        this.setState({
          einvoiceDetails: {
            ...res,
            submitted_date: date,
          },
        });
      }

      if (res?.qrCode) {
        this.setState({
          qrCode: res?.qrCode,
        });
      }
    });
  };
  validateFields = () => {
    const { einvoiceDetails } = this.state;
    const { tinInputValue, addressInputValue } = this.state;

    const errors = {
      tin: false,
      address: false,
    };

    if (einvoiceDetails?.customer?.TIN === "-" && !tinInputValue.trim()) {
      errors.tin = true;
      Toast({
        type: "error",
        message: "TIN is required",
      });
    }

    if (!einvoiceDetails?.customer?.TIN && !tinInputValue.trim()) {
      errors.tin = true;
      Toast({
        type: "error",
        message: "TIN is required",
      });
    }

    this.setState({ errors });

    // Return true if no errors
    return !errors.tin && !errors.address;
  };

  handleEinvoiceSubmit = () => {
    const { einvoiceDetails, tinInputValue, SST, reg_no, state } = this.state;
    if (this.validateFields()) {
      // Prepare updated data with potentially new TIN and address
      const payload = {
        tin_number:
          (einvoiceDetails?.customer?.TIN &&
            einvoiceDetails?.customer?.TIN !== "-") ||
          tinInputValue,
        registration_number: reg_no,
        sst: SST,
        state: state,
      };

      this.props
        .commonCreateApi(
          `einvoice/submit/${this.props.match.params.id}/`,
          payload
        )
        .then((res) => {
          if (res?.status === "error") {
            Toast({
              type: "success",
              message: res?.message,
            });
          } else {
            Toast({
              type: "success",
              message: "E-Invoice Submitted Successfully",
            });
            this.setState({
              openEinvoice: false,
              tinInputValue: "",
              addressInputValue: "",
              einvoiceBtnStatus: res?.einvoice_submitted,
            });
          }
        });
    }
  };
  handleEinvoiceDialog = () => {
    this.setState({
      openEinvoice: false,
    });
  };

  handleInputChange = (field, value) => {
    if (field === "tin") {
      this.setState({ tinInputValue: value });
    } else if (field === "address") {
      this.setState({ addressInputValue: value });
    } else if (field === "reg_no") {
      this.setState({ reg_no: value });
    } else if (field === "SST") {
      this.setState({ SST: value });
    } else if (field === "state") {
      this.setState({ state: value });
    }
  };

  // MerchantReceiptImg
  handleGetMerchantImage = async () => {
    const { photoSections } = this.state;
    const transacno = this.props.match.params.id;

    try {
      const res = await this.props.getCommonApi(
        `postaudimageupload/?sa_transacno=${transacno}&pay_type=${Object.keys(
          photoSections
        )}`
      );
      const data = res?.data || [];

      const updatedPhotoSections = { ...photoSections };
      console.log(photoSections);
      data.forEach((item, index) => {
        console.log(item.sa_transacno);
        if (item.sa_transacno === transacno) {
          //const payType = item.pay_type + "-" + item.id;
          //Yoonus
          //const payType = item.pay_type;
          const payType = `${item.pay_type}-${index + 1}`
          console.log(payType);
          if (updatedPhotoSections[payType]) {
            updatedPhotoSections[payType].id = item.id;
            updatedPhotoSections[payType].image = item.merchantreceiptimg;
            updatedPhotoSections[payType].isUploading = false;
          }
        }

      });
      console.log(updatedPhotoSections);

      this.setState({ photoSections: updatedPhotoSections });

    } catch (err) {
      console.log("Error fetching merchant image:", err);
    }
  };

  // MerchantReceiptImg
  handleMerchant = () => {
    this.setState({
      isMerchantPopup: true,
    });
    this.handleGetMerchantImage();
  };
  // MerchantReceiptImg
  handleMerchantDialog = () => {
    this.setState({
      isMerchantPopup: false,
    });
  };
  // MerchantReceiptImg
  updateSectionState = (section, data) => {
    this.setState((prevState) => ({
      photoSections: {
        ...prevState.photoSections,
        [section]: {
          ...prevState.photoSections[section],
          ...data,
        },
      },
    }));
  };

  // MerchantReceiptImg
  uploadImage = async (section, imageData, fileName) => {
    this.updateSectionState(section, { isUploading: true });

    try {
      function dataURLtoFile(dataurl, filename) {
        const arr = dataurl.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      }
      const formData = new FormData();
      formData.append("sa_transacno", this.props.match.params.id);
      formData.append("pay_type", section);
      formData.append(
        "image",
        dataURLtoFile(imageData, `${section}.jpeg`)
        //dataURLtoFile(imageData, fileName || `${section}.jpeg`)
      );
      const { photoSections } = this.state;
      const sectionData = photoSections[section];
      let res;

      if (sectionData?.id) {
        res = await this.props.commonUpdateApi(
          `postaudimageupload/${sectionData.id}/`,
          formData
        );
      } else {
        res = await this.props.commonCreateApi(`postaudimageupload/`, formData);
      }
      this.handleGetMerchantImage();
      const newId = res?.id;
      this.updateSectionState(section, {
        image: imageData,
        isUploading: false,
        showCamera: false,
        ...(newId && { id: newId }),
      });
    } catch (error) {
      console.error(`Error uploading image for ${section}:`, error);
      this.updateSectionState(section, { isUploading: false });
    }
  };

  // MerchantReceiptImg
  capturePhoto = (section) => {
    const webcam = this[`webcam_${section}`];
    if (webcam) {
      const imageSrc = webcam.getScreenshot();
      const timestamp = Date.now();
      const filename = `captured_${section}_${timestamp}.jpeg`;
      this.uploadImage(section, imageSrc, filename);
    }
  };

  // MerchantReceiptImg
  handleFileUpload = (section, event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.uploadImage(section, e.target.result, file.name);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
    event.target.value = "";
  };

  // MerchantReceiptImg
  toggleCamera = (section) => {
    this.updateSectionState(section, {
      showCamera: !this.state.photoSections[section].showCamera,
    });
  };

  // MerchantReceiptImg
  removeImage = (section) => {
    this.props
      .commonDeleteApi(
        `postaudimageupload/?sa_transacno=${this.props.match.params.id}&pay_type=${section}`
      )
      .then(() => {
        this.updateSectionState(section, { image: null });
        this.handleGetMerchantImage();
      });
  };
  // MerchantReceiptImg
  renderPhotoSection = (section, title) => {
    const sectionData = this.state.photoSections[section];
    if (!sectionData) return null;
    const { image, isCameraAvailable, showCamera, isUploading } = sectionData;

    const videoConstraints = {
      width: 400,
      height: 300,
      facingMode: "user",
    };

    return (
      <div className="col-3 p-2">
        <div className="border rounded p-3" style={{ minHeight: "400px" }}>
          <h6 className="text-center mb-3">Payment Mode: {title}</h6>

          {isUploading ? (
            <div
              className="d-flex flex-column align-items-center justify-content-center"
              style={{ height: "250px" }}
            >
              <div className="spinner-border text-primary mb-2" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : !image ? (
            <div>
              {isCameraAvailable && showCamera ? (
                <div>
                  <Webcam
                    audio={false}
                    ref={(ref) => (this[`webcam_${section}`] = ref)}
                    screenshotFormat="image/jpeg"
                    width="100%"
                    height={300}
                    videoConstraints={videoConstraints}
                  />
                  <div className="mt-2">
                    <NormalButton
                      mainbg={true}
                      className="col-12 fs-12 mb-2"
                      label="Capture"
                      onClick={() => this.capturePhoto(section)}
                    />
                    <NormalButton
                      resetbg={true}
                      className="col-12 fs-12"
                      label="Cancel"
                      onClick={() => this.toggleCamera(section)}
                    />
                  </div>
                </div>
              ) : (
                <div>
                  <div
                    className="border-dashed border-2 d-flex align-items-center justify-content-center"
                    style={{ height: "300px", backgroundColor: "#f8f9fa" }}
                  >
                    <span className="text-muted">No photo uploaded</span>
                  </div>

                  <div className="mt-3">
                    {isCameraAvailable && (
                      <NormalButton
                        mainbg={true}
                        className="col-12 fs-12 mb-2"
                        label="Capture Photo"
                        onClick={() => this.toggleCamera(section)}
                      />
                    )}
                    <input
                      type="button"
                      value="Upload Photo"
                      className="btn cursor-pointer mainbg-btn col-12 fs-12"
                      onClick={() =>
                        document.getElementById(`file_${section}`).click()
                      }
                    />
                    <input
                      type="file"
                      id={`file_${section}`}
                      className="d-none"
                      accept="image/*"
                      onChange={(e) => this.handleFileUpload(section, e)}
                    />
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div>
              <div className="mb-3">
                <img
                  src={image}
                  alt={`${title} payment`}
                  style={{
                    width: "100%",
                    height: "300px",
                    objectFit: "contain",
                  }}
                  className="rounded"
                />
              </div>

              <div className="d-flex justify-content-center">
                <NormalButton
                  resetbg={true}
                  className="fs-12 px-3"
                  label="Remove & Retake"
                  onClick={() => this.removeImage(section)}
                />
              </div>

              <div className="text-center mt-2">
                <small className="text-success">
                  ✓ Image uploaded successfully
                </small>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    let {
      responseData = {},
      downloadlLink,
      receiptDownloadLink,
      isOpenModal,
      voucherPromo,
      voucherpromo,
      isPrintPdfClick,
      isPrintPdfPreview,
      isBackendPrintEnable,

      //Einvoice
      openEinvoice,
      einvoiceDetails,
      einvoiceBtnStatus,
      tinInputValue,
      addressInputValue,
      qrCode,
      SST,
      reg_no,
      state,

      // MerchantReceiptImg
      isMerchantPopup,
      selectedMethods,

    } = this.state;
    let {
      hdr_data = [],
      dtl_data = [],
      sub_data = {},
      taud_data = [],
      footer = {},
      company_hdr = {},
      taud_sub = {},
    } = responseData;

    return (
      <>
        <div className="print-section container">
          <div className="print-bill">
            {this.state.templateList && (
              <PrintView
                responseData={responseData}
                stateData={this.state.templateList[0]}
                handleSignSaveClick={(imgData) =>
                  this.handleSignSaveClick(imgData)
                }
              />
            )}

            {/* <div className="receipt card" id="printableArea">
              <div className="row py-3">
                {this.handleChangeCheckStatus(
                  this.state.templateList[0]?.headerList,
                  "Company Name"
                ) && (
                  <div className="col-md-12">
                    <h6 className="text-center fs-18">
                      {" "}
                      {company_hdr?.name ? company_hdr?.name : ""}
                      {"  "}
                      {this.handleChangeCheckStatus(
                        this.state.templateList[0]?.headerList,
                        "ROC"
                      ) &&
                        company_hdr?.company_reg_no &&
                        ` (ROC No: 
                      ${company_hdr?.company_reg_no || ""})`}
                    </h6>
                  </div>
                )}
              </div>
              <div className="logoHeaderSection" style={{ fontSize: "1rem" }}>
                <div className="row">
                  <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.headerList,
                      "Logo"
                    ) && (
                      <div className="d-flex justify-content-center">
                        <img
                          src={company_hdr ? company_hdr.logo : ""}
                          alt=""
                          width={"100px"}
                          height={"110px"}
                          className="printImgContainer"
                        />
                      </div>
                    )}
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.headerList,
                      "Company Address"
                    ) && (
                      <p className="receipt-detail">
                        {company_hdr ? company_hdr.address : ""}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="bill-header" style={{ fontSize: "1rem" }}>
                <div className="row ">
                  <div className="col-6">
                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "Code"
                    ) && (
                      <div className="row">
                        <div className="col-3 f-600">Code</div>
                        <div className="col-9">
                          : {hdr_data ? hdr_data.sa_custno : ""}
                        </div>
                      </div>
                    )}

                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "Name"
                    ) && (
                      <div className="row">
                        <div className="col-3  f-600">Name</div>
                        <div className="col-9">
                          : {hdr_data ? hdr_data.sa_custname : ""}
                        </div>
                      </div>
                    )}

                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "NRIC"
                    ) && (
                      <>
                        {hdr_data && hdr_data.is_nric ? (
                          <div className="row">
                            <div className="col-3  f-600">NRIC</div>
                            <div className="col-9">
                              : {hdr_data ? hdr_data.nric : ""}
                            </div>
                          </div>
                        ) : null}
                      </>
                    )}

                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "Cust Refer"
                    ) && (
                      <div className="row">
                        <div className="col-3  f-600">Cust Refer</div>
                        <div className="col-9">
                          : {hdr_data ? hdr_data.cust_refer : ""}
                        </div>
                      </div>
                    )}
                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "Cust Phone"
                    ) && (
                      <div className="row">
                        <div className="col-3  f-600">Cust Phone</div>
                        <div className="col-9">
                          : {hdr_data ? hdr_data.cust_phone2 : ""}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-6">
                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "Trans"
                    ) && (
                      <div className="row">
                        <div className="col-3  f-600">Trans</div>
                        <div className="col-9">
                          : {hdr_data ? hdr_data.trans : ""}
                        </div>
                      </div>
                    )}

                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "Date"
                    ) && (
                      <div className="row">
                        <div className="col-3  f-600">Date</div>
                        <div className="col-9">
                          : {hdr_data ? hdr_data.sa_date : ""}
                        </div>
                      </div>
                    )}

                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "Time"
                    ) && (
                      <div className="row">
                        <div className="col-3  f-600">Time</div>
                        <div className="col-9">
                          : {hdr_data ? hdr_data.sa_time : ""}
                        </div>
                      </div>
                    )}
                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "Issued"
                    ) && (
                      <div className="row">
                        <div className="col-3  f-600">Issued</div>
                        <div className="col-9">
                          : {hdr_data ? hdr_data.issued : ""}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="bill-detail mt-4 py-1"
                id="billDetailsHide"
                style={{ fontSize: ".915rem" }}
              >
                <div className="row m-0 table-header  f-600">
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Sno"
                  ) && <div className="col text-left">No.</div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Desc"
                  ) && <div className="col-3 text-left">Description</div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Qty"
                  ) && <div className="col text-left">Qty</div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table U/P"
                  ) && <div className="col text-left">U/P</div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Disc"
                  ) && <div className="col text-left">Disc.</div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table N/P"
                  ) && <div className="col text-left">N/P</div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Paid"
                  ) && <div className="col text-left">Paid</div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Balance"
                  ) && <div className="col d-none">Balance</div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Sold By"
                  ) && <div className="col text-left">Sold By</div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Service By"
                  ) && <div className="col text-left">Service By</div>}
                </div>
                <div id="firstloopdataHide">
                  {dtl_data.length > 0
                    ? dtl_data.map((item, index) => {
                        return (
                          <div className="row m-0 mt-2" key={index}>
                            {this.handleChangeCheckStatus(
                              this.state.templateList[0]?.bodyList,
                              "Table Sno"
                            ) && (
                              <div className="col text-left">{index + 1}</div>
                            )}
                            {this.handleChangeCheckStatus(
                              this.state.templateList[0]?.bodyList,
                              "Table Desc"
                            ) && (
                              <div className="col-3 text-left">
                                {item.dt_itemdesc}
                              </div>
                            )}
                            {this.handleChangeCheckStatus(
                              this.state.templateList[0]?.bodyList,
                              "Table Qty"
                            ) && (
                              <div className="col text-left">{item.dt_qty}</div>
                            )}
                            {this.handleChangeCheckStatus(
                              this.state.templateList[0]?.bodyList,
                              "Table U/P"
                            ) && (
                              <div className="col text-left">
                                {item.dt_price}
                              </div>
                            )}

                            {this.handleChangeCheckStatus(
                              this.state.templateList[0]?.bodyList,
                              "Table Disc"
                            ) && (
                              <div className="col text-left">
                                {item.discount}
                              </div>
                            )}
                            {this.handleChangeCheckStatus(
                              this.state.templateList[0]?.bodyList,
                              "Table N/P"
                            ) && (
                              <div className="col text-left">
                                {item.dt_transacamt}
                              </div>
                            )}

                            {this.handleChangeCheckStatus(
                              this.state.templateList[0]?.bodyList,
                              "Table Paid"
                            ) && (
                              <div className="col text-left">
                                {item.dt_deposit}
                              </div>
                            )}
                            {this.handleChangeCheckStatus(
                              this.state.templateList[0]?.bodyList,
                              "Table Balance"
                            ) && (
                              <div className="col d-none">{item.balance}</div>
                            )}
                            {this.handleChangeCheckStatus(
                              this.state.templateList[0]?.bodyList,
                              "Table Sold By"
                            ) && (
                              <div className="col text-left">
                                {item.sales_staff}
                              </div>
                            )}
                            {this.handleChangeCheckStatus(
                              this.state.templateList[0]?.bodyList,
                              "Table Service By"
                            ) && (
                              <div className="col text-left">
                                {item.work_staff}
                              </div>
                            )}
                          </div>
                        );
                      })
                    : ""}
                </div>

                <div className="row table-header sub-total m-0 fs-14 f-600 mt-5">
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Sno"
                  ) && <div className="col text-left"></div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Desc"
                  ) && <div className="col-3 text-left"></div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Qty"
                  ) && <div className="col text-left">{sub_data.tot_qty}</div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table U/P"
                  ) && (
                    <div className="col text-left">{sub_data.tot_price}</div>
                  )}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Disc"
                  ) && <div className="col text-left">{sub_data.tot_disc}</div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table N/P"
                  ) && <div className="col text-left">{sub_data.tot_net}</div>}

                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Paid"
                  ) && <div className="col text-left">{sub_data.tot_paid}</div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Balance"
                  ) && <div className="col d-none">{sub_data.tot_bal}</div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Sold By"
                  ) && <div className="col text-left"></div>}
                  {this.handleChangeCheckStatus(
                    this.state.templateList[0]?.bodyList,
                    "Table Service By"
                  ) && <div className="col text-left"></div>}
                </div>
              </div>
              <div className="payment-detail my-4  fw-600 mb-4">
                <div className="row m-0">
                  <div className="col-7">
                    <div className="row payment-header">
                      <div className="col-4">No</div>
                      <div className="col-4">Type</div>
                      <div className="col-4 text-right">Amount</div>
                    </div>
                    {taud_data.length > 0
                      ? taud_data.map((item, index) => {
                          return (
                            <div className="row payment-header" key={index}>
                              <div className="col-4">{item.pay_rem1}</div>
                              <div className="col-4">{item.pay_type_name}</div>
                              <div className="col-4 text-right">
                                $ {item.pay_amt}
                              </div>
                            </div>
                          );
                        })
                      : ""}
                    <div className="row payment-footer">
                      <div className="col-4 fs-13">{taud_sub.gst_label}</div>
                      <div className="col-4">Total</div>
                      <div className="col-4 text-right">{taud_sub.total}</div>
                    </div>
                  </div>
                  <div className="col-5 text-right">
                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "Sub Total"
                    ) && (
                      <div className="row">
                        <div className="col-6">Sub Total :</div>
                        <div className="col-6 text-right">
                          {sub_data.sub_total}
                        </div>
                      </div>
                    )}

                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "GST"
                    ) && (
                      <div className="row">
                        <div className="col-6">GST :</div>
                        <div className="col-6 text-right">{taud_sub.gst}</div>
                      </div>
                    )}
                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "Rounding"
                    ) && (
                      <div className="row">
                        <div className="col-6">Rounding :</div>
                        <div className="col-6 text-right">
                          {taud_sub.rounding}
                        </div>
                      </div>
                    )}

                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "Grand Total"
                    ) && (
                      <div className="row">
                        <div className="col-6">Grand Total :</div>
                        <div className="col-6 text-right">
                          {taud_sub.grand_tot}
                        </div>
                      </div>
                    )}

                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "Deposit"
                    ) && (
                      <div className="row">
                        <div className="col-6">Deposit :</div>
                        <div className="col-6 text-right">
                          {sub_data.tot_paid}
                        </div>
                      </div>
                    )}

                    {this.handleChangeCheckStatus(
                      this.state.templateList[0]?.bodyList,
                      "Outstanding"
                    ) && (
                      <div className="row">
                        <div className="col-6">Outstanding :</div>
                        <div className="col-6 text-right">
                          {sub_data.outstanding}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <PrepaidDesc footer={footer} />

              <div className=" mt-2" style={{ bottom: 0 }}>
                {this.handleChangeCheckStatus(
                  this.state.templateList[0]?.footerList,
                  "Remarks"
                ) && (
                  <>
                    {footer.remark && (
                      <p className="py-1">Remark: {footer.remark}</p>
                    )}
                  </>
                )}
                {this.handleChangeCheckStatus(
                  this.state.templateList[0]?.footerList,
                  "Footer List"
                ) && (
                  <>
                    {footer.footer1 ? <p>{footer.footer1}</p> : ""}
                    {footer.footer2 ? <p>{footer.footer2}</p> : ""}
                    {footer.footer3 ? <p>{footer.footer3}</p> : ""}
                    {footer.footer4 ? <p>{footer.footer4}</p> : ""}
                  </>
                )}

                {this.handleChangeCheckStatus(
                  this.state.templateList[0]?.footerList,
                  "Terms & Condition"
                ) && (
                  <div className="row">
                    <p className="fs-10">{NewLineText(termsText)}</p>
                  </div>
                )}

                {this.handleChangeCheckStatus(
                  this.state.templateList[0]?.footerList,
                  "Signature"
                ) && (
                  <div className="d-flex justify-content-end ">
                    <div className="col-3 text-center p-1">
                      {company_hdr && company_hdr.cust_sig && (
                        <>
                          <img
                            className={`sigImage`}
                            alt=""
                            width={200}
                            height={150}
                            src={company_hdr.cust_sig}
                          />
                          <p>Customer Signature</p>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div> */}
            <div
              ref={(el) => (this.thermalPrinterRef = el)}
              className="receipt card"
              id="printableAreaThermal"
              style={{ height: "auto" }}
              // style={{ overflow: "hidden" }}
            >
              <div className="printableAreaInner">
                <div className="thermal-logo-header">
                  {company_hdr && (
                    <div className="row justify-content-center">
                      <div className="thermal-logo-container">
                        <img
                          src={company_hdr ? company_hdr.logo : ""}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>
                    </div>
                  )}

                  <div className="row justify-content-center pb-2">
                    <div className="text-center pl-0">
                      <h3 className="bill-head">
                        {company_hdr ? company_hdr.name : ""}
                      </h3>
                      <p className="receipt-detail">
                        {company_hdr ? NewLineText(company_hdr?.address) : ""}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bill-header d-flex justify-content-center ">
                  <div className="row ">
                    <div className="col-12">
                      <div className="row">
                        <div className="col-5 fw-600">Code</div>
                        <div className="col-7">
                          : {hdr_data ? hdr_data.sa_custno : ""}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-5  fw-600">Name</div>
                        <div className="col-7">
                          : {hdr_data ? hdr_data.sa_custname : ""}
                        </div>
                      </div>

                      {hdr_data && hdr_data.is_nric ? (
                        <div className="row">
                          <div className="col-5  fw-600">NRIC</div>
                          <div className="col-7">
                            : {hdr_data ? hdr_data.nric : ""}
                          </div>
                        </div>
                      ) : null}
                      <div className="row">
                        <div className="col-5  fw-600">Cust Refer</div>
                        <div className="col-7">
                          : {hdr_data ? hdr_data.cust_refer : ""}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-5  fw-600">Cust Phone</div>
                        <div className="col-7">
                          : {hdr_data ? hdr_data.cust_phone2 : ""}
                        </div>
                      </div>
                      {/* <div className="row">
                                            <div className="col-5  fw-600">Member:</div>
                                            <div className="col-7">: {hdr_data ? hdr_data.member : ""}</div>
                                        </div> */}
                    </div>
                    <div className="col-12">
                      <div className="row">
                        <div className="col-5  fw-600">Trans</div>
                        <div className="col-7">
                          : {hdr_data ? hdr_data.trans : ""}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-5  fw-600">Date</div>
                        <div className="col-7">
                          : {hdr_data ? hdr_data.sa_date : ""}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-5  fw-600">Time</div>
                        <div className="col-7">
                          : {hdr_data ? hdr_data.sa_time : ""}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-5  fw-600">Issued</div>
                        <div className="col-7">
                          : {hdr_data ? hdr_data.issued : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 d-flex justify-content-center">
                    <div className="bill-detail mt-4 py-1" id="billDetailsHide">
                      <div className="row m-0 table-header  fw-600">
                        <div className="col-2">No.</div>
                        <div className="col-5 text-left">Description</div>
                        <div className="col-2 ">Qty</div>
                        <div className="col-3 text-right">U/P</div>
                      </div>
                      <div id="firstloopdataHide">
                        {dtl_data.length > 0
                          ? dtl_data.map((item, index) => {
                              return (
                                <div className="row m-0 mt-2" key={index}>
                                  <div className="col-2">{index + 1}</div>
                                  <div className="col-5 text-left">
                                    {item.dt_itemdesc}
                                  </div>
                                  <div className="col-2">{item.dt_qty}</div>
                                  <div className="col-3 text-right">
                                    {item.dt_price}
                                  </div>
                                </div>
                              );
                            })
                          : ""}
                      </div>

                      <div className="row table-header sub-total m-0  fw-600 mt-5">
                        {/* <div className="col-4 text-right">{sub_data.sub_total}</div> */}
                        <div className="col-2 text-right"></div>
                        <div className="col-5 text-right"></div>
                        <div className="col-2">{sub_data.tot_qty}</div>
                        <div className="col-3 text-right">
                          {sub_data.tot_price}
                        </div>
                      </div>

                      <div className="row payment-detail mt-3 fw-600">
                        <div className="col-4"></div>
                        <div className="col-8">
                          <div className="row">
                            <div className="col-7 text-right">
                              <div>GST :</div>
                            </div>
                            <div className="col-5 text-right">
                              <div>{taud_sub.gst}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row payment-detail  fw-600">
                        <div className="col-4"></div>
                        <div className="col-8">
                          <div className="row">
                            <div className="col-7 text-right">
                              <div>Rounding :</div>
                            </div>
                            <div className="col-5 text-right">
                              <div> {taud_sub.rounding}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row payment-detail  fw-600">
                        <div className="col-4"></div>
                        <div className="col-8">
                          <div className="row">
                            <div className="col-7 text-right">
                              <div>Grand Total :</div>
                            </div>
                            <div className="col-5 text-right">
                              <div> {taud_sub.grand_tot}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row payment-detail  fw-600">
                        <div className="col-4"></div>
                        <div className="col-8">
                          <div className="row">
                            <div className="col-7 text-right">
                              <div>Deposit :</div>
                            </div>
                            <div className="col-5 text-right">
                              <div> {sub_data.tot_paid}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row payment-detail  fw-600">
                        <div className="col-4"></div>
                        <div className="col-8">
                          <div className="row">
                            <div className="col-7 text-right">
                              <div>Outstanding :</div>
                            </div>
                            <div className="col-5 text-right">
                              <div> {sub_data.outstanding}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="pt-5 d-flex text-center action-buttons">
              {/* <div className="w-100 mr-2">
                <NormalButton
                  onClick={() => this.handleImageToPrint()}
                  label="Print"
                  success={true}
                  className="print"
                />
              </div> */}
              <div className="col-md-2 col-12">
                <NormalButton
                  // buttonClass={"print"}
                  // mainbg={true}
                  className="print colorTheme4"
                  label="print"
                  // outline={false}
                  onClick={async () => {
                    if (isBackendPrintEnable) {
                      printJS(downloadlLink);
                    } else {
                      await this.setState({
                        isPrintPdfPreview: true,
                      });
                    }
                  }}
                />

                {isPrintPdfPreview ? (
                  <PDFDownloadLink
                    document={
                      <PrintPreview
                        transactionOrderChangeList={
                          this.props.transactionOrderChangeList
                        }
                        responseData={responseData}
                        accountHeader={company_hdr}
                        landscape={false}
                        customerSingature={this.state.cust_sign}
                        settingList={
                          this.state.templateList[0] &&
                          this.state.templateList[0]
                        }
                      />
                    }
                  >
                    {({ blob, url, loading, error }) =>
                      !loading && url ? this.handlePrintPreview(url) : null
                    }
                  </PDFDownloadLink>
                ) : null}
              </div>

              {this.props.tokenDetails?.studioAbooking && (
                <div className="col-md-2 col-12 ">
                  <NormalButton
                    //mainbg={true}
                    className="colorTheme5"
                    label="Receipt"
                    // outline={false}
                    // onClick={() => this.printIfContentExists()}
                    onClick={async () => {
                      if (receiptDownloadLink) {
                        printJS(receiptDownloadLink);
                      }
                    }}
                  />
                </div>
              )}

              {this.props.tokenDetails?.thermalprint && (
                <div className="col-md-2 col-12">
                  <NormalButton
                    // buttonClass={"print"}
                    // mainbg={true}
                    className="colorTheme5"
                    label="thermal"
                    // onClick={() => this.printIfContentExists()}
                    // outline={false}
                    onClick={() => {
                      this.setState({
                        isPrintPdfClick: true,
                      });
                    }}
                  />

                  {isPrintPdfClick ? (
                    <PDFDownloadLink
                      document={
                        //navis
                        // <Thermal
                        //   responseData={responseData}
                        // currency={localStorage.getItem("currency")}
                        //   accountHeader={company_hdr}
                        //   landscape={false}
                        // />

                        //lohassians malaysia
                        //<ThermalMalaysia
                        //  responseData={responseData}
                        //  currency={localStorage.getItem("currency")}
                        //  accountHeader={company_hdr}
                        //  landscape={false}
                        ///>

                        //coulisseheir and lovedebe
                        <Coulisseheir
                          responseData={responseData}
                          currency={localStorage.getItem("currency")}
                          accountHeader={company_hdr}
                          landscape={false}
                        />

                        // <Luxelle
                        //   responseData={responseData}
                        // currency={localStorage.getItem("currency")}
                        //   accountHeader={company_hdr}
                        //   landscape={false}
                        // />
                      }
                    >
                      {({ blob, url, loading, error }) =>
                        !loading && url ? this.handlePrintPdfFormat(url) : null
                      }
                    </PDFDownloadLink>
                  ) : null}
                </div>
              )}

              {/* <ReactToPrint
                pageStyle={pageStyle}
                trigger={() => {
                  return (
                    <div className="w-100 mr-2">
                      <NormalButton
                        onClick={() => this.handleThermalPrinter()}
                        label="Thermal Print"
                        success={true}
                        className="print"
                      />
                    </div>
                  );
                }}
                content={() => this.thermalPrinterRef}
              /> */}

              <div className="w-100 ml-2">
                {this.props.tokenDetails?.showemail && (
                  <NormalButton
                    onClick={this.handleShare}
                    label="Social"
                    className="share colorTheme6"
                  />
                )}
              </div>

              <div className="w-100 ml-2">
                {this.props.tokenDetails?.showsms && (
                  <NormalButton
                    onClick={this.handleSendSMS}
                    label="SMS"
                    className="share colorTheme7"
                  />
                )}
              </div>

              {/* MerchantReceiptImg */}
              {this.props.tokenDetails?.merchantreceiptimg && (
                <div className="w-100 ml-2">
                  <NormalButton
                    onClick={this.handleMerchant}
                    label="Merchant Receipt"
                    className="share colorTheme4"
                  />
                </div>
              )}

              {/* EInvoice */}
              {this.props.tokenDetails?.einvoice && (
                <div className="w-100 ml-2">
                  <button
                    className="einvoice-btn"
                    onClick={this.handleEinvoicePopup}
                    style={{
                      backgroundColor: `${
                        einvoiceBtnStatus ? "#79c253" : "#f02b2b"
                      }`,
                    }}
                  >
                    <div className="einvoice-btn__logo-container">
                      <div className="einvoice-btn__logo-shadow"></div>
                      <img
                        src={
                          einvoiceBtnStatus
                            ? EinvoiceGreenLogo
                            : EinvoiceRedLogo
                        }
                        alt="E-Invoice"
                        className="einvoice-btn__logo"
                      />
                    </div>
                    <span className="einvoice-btn__text">Einvoice</span>
                  </button>
                </div>
              )}

              <div className="w-100 ml-2">
                {this.props?.tokenDetails?.voucherpromo && (
                  <NormalButton
                    // onClick={this.handleSendSMSVoucher}
                    onClick={() => this.setState({ isOpenModal: true })}
                    label="Send SMS Voucher"
                    className="share colorTheme8"
                  />
                )}

                <NormalModal
                  className={"payment-modal"}
                  style={{ minWidth: "65%" }}
                  modal={openEinvoice}
                  handleModal={() => {}}
                >
                  <img
                    onClick={this.handleEinvoiceDialog}
                    className="close cursor-pointer"
                    src={closeIcon}
                    alt=""
                  />
                  <>
                    {einvoiceBtnStatus ? (
                      <div>
                        <div>
                          <h5>E-Invoice Details</h5>
                        </div>
                        <div className="col-12 d-flex">
                          <div className="col-8 d-flex mb-5 mt-4">
                            <div className="col-12 p-0">
                              <div className="d-flex col-12">
                                <p className="col-4">Customer Name :</p>
                                <p className="col-4">
                                  {einvoiceDetails?.cust_name}
                                </p>
                              </div>
                              <div className="d-flex col-12">
                                <p className="col-4">Submitted Date Time :</p>
                                <p className="col-4">
                                  {einvoiceDetails?.submitted_date}
                                </p>
                              </div>
                              <div className="d-flex col-12">
                                <p className="col-4">IRBN Number :</p>
                                <p className="col-4">
                                  {einvoiceDetails?.irbnNo}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-4">
                            <QRCodeSVG
                              value={qrCode}
                              size={125}
                              bgColor={"#ffffff"}
                              fgColor={"#000000"}
                              level={"L"}
                              includeMargin={false}
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div>
                          <h5>Confirm E-Invoice Details</h5>
                        </div>
                        <div className="col-12 d-flex mb-5 mt-4">
                          <div className="col-6 p-0">
                            <div className="d-flex col-12 mb-3">
                              <p className="col-6">Customer Name :</p>
                              <p className="col-6">
                                {einvoiceDetails?.customer?.name}
                              </p>
                            </div>
                            <div className="d-flex col-12 mb-3">
                              <p className="col-6">Customer Number :</p>
                              <p className="col-6">
                                {einvoiceDetails?.customer?.contact}
                              </p>
                            </div>
                            <div className="d-flex col-12 mb-3">
                              <p className="col-6">Email Address :</p>
                              <p className="col-6">
                                {einvoiceDetails?.customer?.email}
                              </p>
                            </div>
                            <div className="d-flex col-12 align-items-center mb-3">
                              <p className="col-6">Address :</p>
                              <p className="col-6">
                                {einvoiceDetails?.customer?.address}
                              </p>
                            </div>
                          </div>
                          <div className="col-6 p-0">
                            <div className="d-flex col-12 align-items-center mb-3">
                              <p className="col-6">Customer TIN No :</p>

                              <div className="col-6">
                                <NormalInput
                                  name="tinInputValue"
                                  placeholder="Enter TIN number"
                                  value={tinInputValue}
                                  onChange={(e) =>
                                    this.handleInputChange(
                                      "tin",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="d-flex col-12 align-items-center mb-3">
                              <p className="col-6">
                                Customer Registration No :
                              </p>
                              <div className="col-6">
                                <NormalInput
                                  name="reg_no"
                                  placeholder="Enter Registration number"
                                  value={reg_no}
                                  onChange={(e) =>
                                    this.handleInputChange(
                                      "reg_no",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="d-flex col-12 align-items-center mb-3">
                              <p className="col-6">Customer SST :</p>
                              <div className="col-6">
                                <NormalInput
                                  name="SST"
                                  placeholder="Enter SST number"
                                  value={SST}
                                  onChange={(e) =>
                                    this.handleInputChange(
                                      "SST",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="d-flex col-12 align-items-center mb-3">
                              <p className="col-6">State :</p>
                              <div className="col-6">
                                <NormalInput
                                  name="state"
                                  placeholder="Enter State"
                                  value={state}
                                  disabled
                                  onChange={(e) =>
                                    this.handleInputChange(
                                      "state",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="d-flex col-12">
                            <p className="col-6">Total Invoice Amt :</p>
                            <p className="col-6">
                              {einvoiceDetails?.amounts?.total}
                            </p>
                          </div>
                          <div className="d-flex col-12">
                            <p className="col-6">Total Tax Amt :</p>
                            <p className="col-6">
                              {einvoiceDetails?.amounts?.tax}
                            </p>
                          </div>
                        </div>
                        <div className="col-12 mt-2 d-flex justify-content-end">
                          <div className="mx-3">
                            <NormalButton
                              onClick={this.handleEinvoiceDialog}
                              label="Cancel"
                              mainbg={true}
                              className=""
                            />
                          </div>
                          <div>
                            <NormalButton
                              onClick={this.handleEinvoiceSubmit}
                              label="Submit"
                              mainbg={true}
                              className=""
                            />
                          </div>
                        </div>
                      </div>
                    )}{" "}
                  </>
                </NormalModal>

                <NormalModal
                  className={"multiple-appointment select-category"}
                  style={{ minWidth: "800px" }}
                  modal={isOpenModal}
                  handleModal={this.handleDialog}
                >
                  <img
                    onClick={this.closeDialog}
                    className="close"
                    src={closeIcon}
                    alt="close"
                  />
                  <h4 className="mb-0">SMS Voucher</h4>
                  <div className="row mb-5">
                    {voucherPromo.map((item) => {
                      return (
                        <>
                          <div className="col-3 my-3 p-2 coupon-button">
                            {/*console.log(item, "item")*/}

                            <NormalButton
                              couponBtn={true}
                              label={item.voucher_desc}
                              leftIcon={Voucher}
                              disabled={item.isactive ? false : true}
                              onClick={() => this.handleData(item)}
                              className="border-0"
                            />
                          </div>
                        </>
                      );
                    })}
                  </div>
                  {console.log(voucherPromo, "item")}
                </NormalModal>

                {/* MerchantReceiptImg */}
                <NormalModal
                  className={"payment-modal"}
                  style={{ minWidth: "80%" }}
                  modal={isMerchantPopup}
                  handleModal={() => {}}
                >
                  <img
                    onClick={this.handleMerchantDialog}
                    className="close cursor-pointer"
                    src={closeIcon}
                    alt=""
                  />
                  <div>
                    <div className="mb-4">
                      <h5>Invoice: {this.props.match.params.id}</h5>
                    </div>
                    <div className="row">
                      {selectedMethods?.map((list, index) => {
                        return this.renderPhotoSection(
                         `${list?.pay_type_name}-${index + 1}`,
                        list?.pay_type_name
                        );
                      })}
                    </div>
                    <div className="row mt-3">
                      <div className="col-12 text-center">
                        <small className="text-muted">
                          Images are automatically saved when captured or
                          uploaded
                        </small>
                      </div>
                    </div>
                  </div>
                </NormalModal>

              </div>
            </div>
          </div>
        </div>
        {/* <div id="print-thermal">
          <CoulisseheirPrint
            responseData={responseData}
            currency={localStorage?.getItem("currency")}
            accountHeader={company_hdr}
            landscape={false}
          />
          <LuxelleNew
            responseData={responseData}
            accountHeader={company_hdr}
            landscape={false}
          />
        </div> */}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  appointmentDetail: state.appointment.appointmentDetail,
  tokenDetails: state.authStore.tokenDetails,
  transactionSettingList: state.transactionStore.transactionSettingList,
  transactionOrderChangeList: state.transactionStore.transactionOrderChangeList,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      commonCreateApi,
      commonUpdateApi,
      commonDeleteApi,
    },
    dispatch
  );
};

export const CustomerReceipt = connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerReceiptClass);
